import Fetching from "../templates/fetching";
const SingleLoading = () => {
    return (
        <>
        <div className="w3-margin-top">
            <Fetching/>
        </div>
        </>
    )
}
export default SingleLoading